export default {
  search: ['请输入您要搜索的资源控制名称', 'Please Enter the Resource Name'],
  info: [
    `资源控制树视图中$0代表导航，$1代表路由，$2代表策略节点，您可以使用“鼠标右键”对每行资源项执行更多操作`,
    'The resource control column can be right-clicked for more operations.'
  ],
  tag: ['分类标签', 'Tag'],
  onlyNav: ['非路由导航', 'Only Nav'],
  routerNav: ['路由导航', 'Router Nav'],
  router: ['路由', 'Router'],
  expand: ['全部展开', 'All Expand'],
  close: ['全部关闭', 'All Close'],
  sort: ['排序', 'Sort'],
  sortYes: ['确认排序', 'Submit Sort'],
  sortCancel: ['取消排序', 'Cancel Sort'],
  sortSuccess: ['资源控制排序成功，正在为您重置导航~', 'The resource control is sorted successfully, and the navigation is being reset for you~'],
  sortError: ['请求错误，数据排序失败', 'Request error, data sorting failed'],
  isSort: ['您已开启排序，请拖拽树视图节点并确认排序', 'You have enabled sorting, please drag the tree view node and confirm the sorting'],
  policy: ['策略', 'Policy'],
  policyRead: ['只读', 'Read'],
  policyReadAndWrite: ['读写', 'Read And Write'],
  aclKey: ['访问控制键', 'Acl Key'],
  aclKeyPlaceHolder: ['请选择访问控制键', 'Please select acl key']
};
